<div class="d-flex justify-content-between">

  <div class="d-flex align-items-center justify-content-center">
    <img class="w-px-26 h-px-26 mr-px-16" [src]="'assets/images/' + data.type + '.png'" alt="">
    <div class="fs-16">{{ data.message }}</div>
  </div>

  <!--  <svg-icon src="assets/icons/close.svg"  class="cursor-pointer"-->
  <!--            (click)="snackBarRef.dismissWithAction()"></svg-icon>-->
  <div class="ml-px-16 cursor-pointer" (click)="snackBarRef.dismissWithAction()">
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.6594 13.4665C14.8179 13.625 14.907 13.84 14.907 14.0641C14.907 14.2883 14.8179 14.5033 14.6594 14.6618C14.5009 14.8203 14.2859 14.9093 14.0618 14.9093C13.8376 14.9093 13.6226 14.8203 13.4641 14.6618L8.99997 10.1962L4.53442 14.6604C4.37591 14.8189 4.16093 14.9079 3.93677 14.9079C3.7126 14.9079 3.49762 14.8189 3.33911 14.6604C3.1806 14.5019 3.09155 14.2869 3.09155 14.0627C3.09155 13.8385 3.1806 13.6236 3.33911 13.4651L7.80466 9.00092L3.34052 4.53537C3.18201 4.37686 3.09296 4.16188 3.09296 3.93771C3.09296 3.71355 3.18201 3.49857 3.34052 3.34006C3.49902 3.18155 3.71401 3.0925 3.93817 3.0925C4.16234 3.0925 4.37732 3.18155 4.53583 3.34006L8.99997 7.8056L13.4655 3.33935C13.624 3.18085 13.839 3.0918 14.0632 3.0918C14.2873 3.0918 14.5023 3.18085 14.6608 3.33935C14.8193 3.49786 14.9084 3.71285 14.9084 3.93701C14.9084 4.16117 14.8193 4.37616 14.6608 4.53467L10.1953 9.00092L14.6594 13.4665Z"
        fill="#8A9398"/>
    </svg>

  </div>
</div>
